import { FilterDropdowns } from './dropdowns.js';
import { StickyBehavior } from './sticky_behavior.js';

const SELECTORS = {
    block: '.wp-block-ssm-filter-navigation',
    button: '.wp-block-ssm-filter-navigation__button',
    offcanvas: '.wp-block-ssm-filter-navigation__offcanvas',
};

const CLASSES = {
    collapsed: 'is-collapsed',
};

const BREAKPOINT = 1200;

// Use WeakMap to track initialized blocks
const initializedBlocks = new WeakMap();

function setupFilterNavigation(block) {
    try {
        const button = block.querySelector(SELECTORS.button);
        const offcanvas = document.querySelector(SELECTORS.offcanvas);

        if (!button) {
            console.warn('Filter navigation button not found');

            return null;
        }

        if (!offcanvas) {
            console.warn('Filter navigation offcanvas not found');

            return null;
        }

        // Initialize sticky behavior
        const stickyBehavior = new StickyBehavior(block, {
            breakpoint: BREAKPOINT,
            collapsedClass: CLASSES.collapsed,
        });

        // Initialize dropdowns
        const filterDropdowns = new FilterDropdowns(offcanvas, {
            baseUrl: window.filterNavigationConfig?.baseUrl || '/blog/archive/',
        });

        // Return cleanup function
        return () => {
            stickyBehavior.destroy();
            filterDropdowns.destroy();
            block.classList.remove(CLASSES.collapsed);
        };
    } catch (error) {
        console.error('Error setting up filter navigation:', error, block);

        return null;
    }
}

export const initFilterNavigation = (block) => {
    // Skip if already initialized
    if (initializedBlocks.has(block)) {
        return initializedBlocks.get(block);
    }

    const cleanup = setupFilterNavigation(block);

    if (cleanup) {
        const instance = {
            destroy() {
                cleanup();
                initializedBlocks.delete(block);
            },
        };

        initializedBlocks.set(block, instance);

        return instance;
    }

    return null;
};

export const FilterNavigation = () => {
    document.querySelectorAll(SELECTORS.block).forEach((block) => {
        initFilterNavigation(block);
    });
};
